import { ContentType } from '../notebook.types';

export abstract class NotebookCellFacade {
  abstract editCellContent(content: string, cellToken: string): void;
  abstract beginEditCell(cellToken: string, cellFrozen?: boolean): void;
  abstract updateContentType(cellToken: string, contentType: ContentType): void;
}
